import React, { useState } from 'react';
import Icon from '../components/Icon';
import { WORKSHOPS, SERVICES } from '../data';

export default function WorkshopsScreen({ discount, initialFilter, onWorkshopClick }) {
  const [filter, setFilter] = useState(initialFilter || 'Todos');

  const filtered = filter === 'Todos'
    ? WORKSHOPS
    : WORKSHOPS.filter(w => w.services.includes(filter));

  return (
    <div className="fade-up" style={{ padding:'20px 20px 100px', maxWidth:1200, margin:'0 auto' }}>
      <div style={{ marginBottom:28 }}>
        <h2 style={{ fontFamily:'var(--font-display)', fontSize:24, fontWeight:700, color:'#fff', marginBottom:8 }}>
          Oficinas Credenciadas
        </h2>
        <p style={{ color:'var(--fg3)', fontSize:16 }}>
          Seu desconto: <strong style={{ color:'var(--orange)', fontFamily:'var(--font-display)' }}>{discount}% OFF</strong> em todos os serviços
        </p>
      </div>

      {/* Filter chips */}
      <div style={{ overflowX:'auto', display:'flex', gap:10, marginBottom:28, paddingBottom:4 }}>
        {['Todos', ...SERVICES.map(s => s.name)].map(f => (
          <button key={f} onClick={() => setFilter(f)} style={{
            padding:'10px 18px',
            borderRadius:12,
            fontSize:14,
            fontWeight:600,
            whiteSpace:'nowrap',
            background: filter === f ? 'var(--orange)' : 'var(--surface)',
            color:       filter === f ? '#fff' : 'var(--fg3)',
            border:     `1px solid ${filter === f ? 'var(--orange)' : 'var(--border)'}`,
            cursor:'pointer',
            transition:'var(--transition)',
          }}>{f}</button>
        ))}
      </div>

      {/* Workshop cards */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(340px, 1fr))', gap:18 }}>
        {filtered.length === 0 ? (
          <div style={{ textAlign:'center', color:'var(--grey-4)', padding:'40px 0', fontSize:14 }}>
            Nenhuma oficina disponível para esse serviço.
          </div>
        ) : filtered.map(w => {
          const iconMap = {
            '🔧': 'wrench', '🛞': 'disc', '⚙️': 'settings',
            '🏎️': 'car', '🛑': 'octagon', '❄️': 'snowflake',
          };
          const iconName = iconMap[w.icon] || 'wrench';

          return (
            <div
              key={w.id}
              onClick={() => onWorkshopClick(w)}
              style={{
                background:'var(--surface)',
                border:'1px solid var(--border)',
                borderRadius:'var(--radius-lg)',
                padding:18,
                cursor:'pointer',
                transition:'var(--transition)',
              }}
              onMouseEnter={e => {
                e.currentTarget.style.borderColor = 'rgba(255,92,0,0.35)';
                e.currentTarget.style.transform   = 'translateY(-2px)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.borderColor = 'var(--border)';
                e.currentTarget.style.transform   = 'translateY(0)';
              }}
            >
              <div style={{ display:'flex', gap:14, marginBottom:12 }}>
                <div style={{
                  width:56, height:56, borderRadius:14,
                  background:'var(--orange-dim)',
                  display:'flex', alignItems:'center', justifyContent:'center',
                  flexShrink:0, border:'1px solid rgba(255,92,0,0.2)',
                }}>
                  <Icon name={iconName} size={32} strokeWidth={2} style={{ color:'var(--orange)' }} />
                </div>
                <div style={{ flex:1 }}>
                  <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
                    <div style={{ fontWeight:700, fontSize:15, color:'#fff' }}>{w.name}</div>
                    <div style={{
                      background:'var(--orange-dim)', color:'var(--orange)',
                      padding:'4px 10px', borderRadius:99, fontSize:12, fontWeight:700,
                    }}>-{discount}%</div>
                  </div>
                  <div style={{ fontSize:12, color:'var(--grey-4)', margin:'3px 0', display:'flex', alignItems:'center', gap:4 }}>
                    <Icon name="map-pin" size={12} />
                    {w.address}
                  </div>
                  <div style={{ fontSize:12, color:'var(--grey-4)', display:'flex', alignItems:'center', gap:8 }}>
                    <span>{w.distance}</span>
                    <span>·</span>
                    <span style={{ display:'flex', alignItems:'center', gap:2 }}>
                      <Icon name="star" size={12} style={{ fill:'var(--orange)', color:'var(--orange)' }} />
                      {w.rating}
                    </span>
                    <span>({w.reviews} aval.)</span>
                  </div>
                </div>
              </div>
              {w.badge && (
                <div className="badge badge-orange" style={{ fontSize:10, marginBottom:10 }}>
                  <Icon name="trending-up" size={12} />
                  {w.badge}
                </div>
              )}
              <div style={{ display:'flex', gap:6, flexWrap:'wrap' }}>
                {w.services.map(s => (
                  <span key={s} className="service-tag">{s}</span>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
